import React from 'react';
import styled from 'styled-components';

interface SpinnerProps {
  spinnerColor?: string;
  backgroundColor?: string;
  visible: boolean;
}
const Spinner = (props: SpinnerProps) => (
  <SpinnerContainer {...props}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </SpinnerContainer>
);
const SpinnerContainer = styled.div<SpinnerProps>`
  display: ${(props) => (props.visible ? 'grid' : 'none')};
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  width: 100%;
  border-radius: 100%;
  align-items: center;
  height: 100%;
  div {
    box-sizing: border-box;
    grid-row: 1/ 2;
    grid-column: 1 / 2;
    margin: 0 auto;
    width: 70%;
    height: 70%;
    border: 2px solid ${(props) => props.spinnerColor || '#fff'};
    border-radius: 50%;
    animation: animatedRing 1.5s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props) => props.spinnerColor || '#fff'} transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes animatedRing {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SpinnerWrapper = styled.div`
  width: 100px;
  height: 100px;
  margin: 0 auto;
`;

export default Spinner;
